const RadioFilter = ({ setFilters, filter }) => {
    const setFilterValue = (e) => {
        setFilters((filters) => {
            const newFilters = [...filters];
            let newValue = null;
            if (e.target.checked) {
                // Handle different value types
                if (e.target.value === 'true') {
                    newValue = true;
                } else if (e.target.value === 'false') {
                    newValue = false;
                } else if (!isNaN(e.target.value)) {
                    newValue = Number(e.target.value);
                } else {
                    newValue = e.target.value;
                }
            }
            newFilters[filters.findIndex((e) => e.index == filter.index)].value = newValue;
            return newFilters
        })
    }
    
    return <div className="d-flex w-100 h-100">
        <div className="bg-white rounded-4 h-100 p-4 border border-gray w-100">
            <h6 className="fw-bold">{filter.name}</h6>
            <div className="d-flex flex-row w-100 flex-wrap user-select-none">
                {filter.options.map((e, index) => {
                    // Create unique ID for each radio button
                    const radioId = `${filter.index}-${e.value}`;
                    
                    return (
                        <div key={index}>
                            <input 
                                className="me-2" 
                                type="radio" 
                                checked={e.value === filter.value} 
                                onChange={(e) => setFilterValue(e)} 
                                value={e.value} 
                                name={filter.index} 
                                id={radioId} 
                            />
                            <label className="pe-2" htmlFor={radioId}>
                                {e.name}
                            </label>
                        </div>
                    )
                })}
            </div>
        </div>
    </div>
}

export default RadioFilter;